/**
 * bunny.net Stream Analytics API
 * Metrics come from data sources with different prerequisites: some need only standard CDN request logging, others need CMCD v1 query-string enrichment or a CMCD v2 player beacon - see each endpoint\'s description for which. If its required source isn\'t enabled, an endpoint returns empty/zero results, not an error.
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { HttpClient, HttpContext, HttpEvent, HttpHeaders, HttpParameterCodec, HttpParams, HttpResponse } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';

import { Observable } from 'rxjs';

import { Configuration } from '../configuration';
import { CustomHttpParameterCodec } from '../encoder';
// @ts-ignore
import { CmcdQualityMetric } from '../model/cmcd-quality-metric';
// @ts-ignore
import { ContentTypeFilter } from '../model/content-type-filter';
// @ts-ignore
import { CoverageResponse } from '../model/coverage-response';
// @ts-ignore
import { PlaybackLifecycleResponse } from '../model/playback-lifecycle-response';
// @ts-ignore
import { QualitySummaryResponse } from '../model/quality-summary-response';
// @ts-ignore
import { QualityTimeSeriesResponse } from '../model/quality-time-series-response';
// @ts-ignore
import { RenditionChangeResponse } from '../model/rendition-change-response';
// @ts-ignore
import { StreamAnalyticsCmcdPostPullZoneIdParameter } from '../model/stream-analytics-cmcd-post-pull-zone-id-parameter';
// @ts-ignore
import { StreamAnalyticsV1PullZoneIdAudienceGeographyGetLimitParameter } from '../model/stream-analytics-v1-pull-zone-id-audience-geography-get-limit-parameter';
// @ts-ignore
import { StreamAnalyticsV1PullZoneIdAudienceViewersCurrentGetWindowSecondsParameter } from '../model/stream-analytics-v1-pull-zone-id-audience-viewers-current-get-window-seconds-parameter';
// @ts-ignore
import { TimeSeriesGranularity } from '../model/time-series-granularity';
// @ts-ignore
import { WaitingViewersResponse } from '../model/waiting-viewers-response';
// @ts-ignore
import { WatchTimeGeographyResponse } from '../model/watch-time-geography-response';
// @ts-ignore
import { WatchTimeResponse } from '../model/watch-time-response';
// @ts-ignore
import { WatchTimeSessionsResponse } from '../model/watch-time-sessions-response';
// @ts-ignore
import { BASE_PATH } from '../variables';

export interface StreamAnalyticsV1PullZoneIdQualityCoverageGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  from: string;
  to: string;
  /** Restrict to specific live stream IDs (repeatable). Combine with videoId to correlate a live stream with its VOD recording - matches either. */
  liveId?: string[];
  /** Restrict to specific video IDs (repeatable). Combine with liveId to correlate a live stream with its VOD recording - matches either. */
  videoId?: string[];
  /** Restrict to live or VOD assets. Only applies when neither liveId nor videoId is given. */
  contentType?: ContentTypeFilter;
  /** Restrict to one or more country codes (repeatable) - matches any of the given values. */
  countryCode?: string[];
  /** Restrict to one or more browsers (repeatable) - matches any of the given values. */
  browser?: string[];
  /** Restrict to one or more operating systems (repeatable) - matches any of the given values. */
  os?: string[];
  /** Restrict to one or more device categories (repeatable) - matches any of the given values. */
  deviceCategory?: string[];
  /** Restrict to one or more bot categories (repeatable) - matches any of the given values. Use \&#39;Human\&#39; for non-bot traffic; every value returned by /audience/bot is accepted here. */
  botCategory?: string[];
}

export interface StreamAnalyticsV1PullZoneIdQualityLifecycleGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  from: string;
  to: string;
  /** Restrict to specific live stream IDs (repeatable). Combine with videoId to correlate a live stream with its VOD recording - matches either. */
  liveId?: string[];
  /** Restrict to specific video IDs (repeatable). Combine with liveId to correlate a live stream with its VOD recording - matches either. */
  videoId?: string[];
  /** Restrict to live or VOD assets. Only applies when neither liveId nor videoId is given. */
  contentType?: ContentTypeFilter;
}

export interface StreamAnalyticsV1PullZoneIdQualityRenditionChangesGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  from: string;
  to: string;
  /** Restrict to specific live stream IDs (repeatable). Combine with videoId to correlate a live stream with its VOD recording - matches either. */
  liveId?: string[];
  /** Restrict to specific video IDs (repeatable). Combine with liveId to correlate a live stream with its VOD recording - matches either. */
  videoId?: string[];
  /** Restrict to live or VOD assets. Only applies when neither liveId nor videoId is given. */
  contentType?: ContentTypeFilter;
  /** Restrict to one or more country codes (repeatable) - matches any of the given values. */
  countryCode?: string[];
  /** Restrict to one or more browsers (repeatable) - matches any of the given values. */
  browser?: string[];
  /** Restrict to one or more operating systems (repeatable) - matches any of the given values. */
  os?: string[];
  /** Restrict to one or more device categories (repeatable) - matches any of the given values. */
  deviceCategory?: string[];
  /** Restrict to one or more bot categories (repeatable) - matches any of the given values. Use \&#39;Human\&#39; for non-bot traffic; every value returned by /audience/bot is accepted here. */
  botCategory?: string[];
}

export interface StreamAnalyticsV1PullZoneIdQualitySummaryGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  from: string;
  to: string;
  /** Restrict to specific live stream IDs (repeatable). Combine with videoId to correlate a live stream with its VOD recording - matches either. */
  liveId?: string[];
  /** Restrict to specific video IDs (repeatable). Combine with liveId to correlate a live stream with its VOD recording - matches either. */
  videoId?: string[];
  /** Restrict to live or VOD assets. Only applies when neither liveId nor videoId is given. */
  contentType?: ContentTypeFilter;
  /** Restrict to one or more country codes (repeatable) - matches any of the given values. */
  countryCode?: string[];
  /** Restrict to one or more browsers (repeatable) - matches any of the given values. */
  browser?: string[];
  /** Restrict to one or more operating systems (repeatable) - matches any of the given values. */
  os?: string[];
  /** Restrict to one or more device categories (repeatable) - matches any of the given values. */
  deviceCategory?: string[];
  /** Restrict to one or more bot categories (repeatable) - matches any of the given values. Use \&#39;Human\&#39; for non-bot traffic; every value returned by /audience/bot is accepted here. */
  botCategory?: string[];
}

export interface StreamAnalyticsV1PullZoneIdQualityTimeseriesGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  from: string;
  to: string;
  /** The CMCD quality metric to bucket, e.g. bitrate or buffer length. More values may be added over time - treat this set as open, not exhaustive. */
  metric: CmcdQualityMetric;
  /** Restrict to specific live stream IDs (repeatable). Combine with videoId to correlate a live stream with its VOD recording - matches either. */
  liveId?: string[];
  /** Restrict to specific video IDs (repeatable). Combine with liveId to correlate a live stream with its VOD recording - matches either. */
  videoId?: string[];
  /** Restrict to live or VOD assets. Only applies when neither liveId nor videoId is given. */
  contentType?: ContentTypeFilter;
  /** Restrict to one or more country codes (repeatable) - matches any of the given values. */
  countryCode?: string[];
  /** Restrict to one or more browsers (repeatable) - matches any of the given values. */
  browser?: string[];
  /** Restrict to one or more operating systems (repeatable) - matches any of the given values. */
  os?: string[];
  /** Restrict to one or more device categories (repeatable) - matches any of the given values. */
  deviceCategory?: string[];
  /** Restrict to one or more bot categories (repeatable) - matches any of the given values. Use \&#39;Human\&#39; for non-bot traffic; every value returned by /audience/bot is accepted here. */
  botCategory?: string[];
  /** Bucket width for the time series. More values may be added over time - treat this set as open, not exhaustive. */
  granularity?: TimeSeriesGranularity;
}

export interface StreamAnalyticsV1PullZoneIdQualityWaitingViewersGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  liveId: string;
  /** Seconds back to look for a waiting-viewer heartbeat (default 60 - the player beacons at most once every 30s, so this covers one missed beat plus timing jitter). */
  windowSeconds?: StreamAnalyticsV1PullZoneIdAudienceViewersCurrentGetWindowSecondsParameter;
}

export interface StreamAnalyticsV1PullZoneIdQualityWatchTimeGeographyGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  from: string;
  to: string;
  /** Restrict to specific live stream IDs (repeatable). Combine with videoId to correlate a live stream with its VOD recording - matches either. */
  liveId?: string[];
  /** Restrict to specific video IDs (repeatable). Combine with liveId to correlate a live stream with its VOD recording - matches either. */
  videoId?: string[];
  /** Restrict to live or VOD assets. Only applies when neither liveId nor videoId is given. */
  contentType?: ContentTypeFilter;
  /** Restrict to one or more viewer countries (ISO-3166 alpha-2, repeatable) - matches any of the given values. The country is determined server-side, not reported by the player - see /quality/watch-time/geography for how. */
  countryCode?: string[];
  /** Maximum number of rows to return. */
  limit?: StreamAnalyticsV1PullZoneIdAudienceGeographyGetLimitParameter;
}

export interface StreamAnalyticsV1PullZoneIdQualityWatchTimeGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  from: string;
  to: string;
  /** Restrict to specific live stream IDs (repeatable). Combine with videoId to correlate a live stream with its VOD recording - matches either. */
  liveId?: string[];
  /** Restrict to specific video IDs (repeatable). Combine with liveId to correlate a live stream with its VOD recording - matches either. */
  videoId?: string[];
  /** Restrict to live or VOD assets. Only applies when neither liveId nor videoId is given. */
  contentType?: ContentTypeFilter;
  /** Restrict to one or more viewer countries (ISO-3166 alpha-2, repeatable) - matches any of the given values. The country is determined server-side, not reported by the player - see /quality/watch-time/geography for how. */
  countryCode?: string[];
}

export interface StreamAnalyticsV1PullZoneIdQualityWatchTimeSessionsGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  from: string;
  to: string;
  /** Restrict to specific live stream IDs (repeatable). Combine with videoId to correlate a live stream with its VOD recording - matches either. */
  liveId?: string[];
  /** Restrict to specific video IDs (repeatable). Combine with liveId to correlate a live stream with its VOD recording - matches either. */
  videoId?: string[];
  /** Restrict to live or VOD assets. Only applies when neither liveId nor videoId is given. */
  contentType?: ContentTypeFilter;
  /** Restrict to one or more viewer countries (ISO-3166 alpha-2, repeatable) - matches any of the given values. The country is determined server-side, not reported by the player - see /quality/watch-time/geography for how. */
  countryCode?: string[];
  /** Sort longest watch time first when true, shortest first when false. */
  descending?: boolean;
  /** Maximum number of session rows to return. */
  limit?: StreamAnalyticsV1PullZoneIdAudienceGeographyGetLimitParameter;
}

@Injectable({
  providedIn: 'root',
})
export class QualityService {
  protected basePath = 'https://mc-cwlfiqxct9.bunny.run';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach((elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach((k) => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k)));
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * CMCD coverage ratio
   * Ratio of streaming requests carrying CMCD v1 (Request Mode) query-string telemetry, out of total streaming requests logged at the CDN edge, between \&#39;from\&#39; and \&#39;to\&#39;. Requires no client beacon - a low or zero ratio means the player isn\&#39;t sending CMCD v1, not that the API is broken. Can be narrowed to a single country/browser/OS/device category/bot category with the corresponding filter parameter.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdQualityCoverageGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityCoverageGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<CoverageResponse>;
  public streamAnalyticsV1PullZoneIdQualityCoverageGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityCoverageGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<CoverageResponse>>;
  public streamAnalyticsV1PullZoneIdQualityCoverageGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityCoverageGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<CoverageResponse>>;
  public streamAnalyticsV1PullZoneIdQualityCoverageGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityCoverageGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdQualityCoverageGet.');
    }
    const from = requestParameters?.from;
    if (from === null || from === undefined) {
      throw new Error('Required parameter from was null or undefined when calling streamAnalyticsV1PullZoneIdQualityCoverageGet.');
    }
    const to = requestParameters?.to;
    if (to === null || to === undefined) {
      throw new Error('Required parameter to was null or undefined when calling streamAnalyticsV1PullZoneIdQualityCoverageGet.');
    }
    const liveId = requestParameters?.liveId;
    const videoId = requestParameters?.videoId;
    const contentType = requestParameters?.contentType;
    const countryCode = requestParameters?.countryCode;
    const browser = requestParameters?.browser;
    const os = requestParameters?.os;
    const deviceCategory = requestParameters?.deviceCategory;
    const botCategory = requestParameters?.botCategory;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (from !== undefined && from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>from, 'from');
    }
    if (to !== undefined && to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>to, 'to');
    }
    if (liveId) {
      liveId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'liveId');
      });
    }
    if (videoId) {
      videoId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'videoId');
      });
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }
    if (countryCode) {
      countryCode.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'countryCode');
      });
    }
    if (browser) {
      browser.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'browser');
      });
    }
    if (os) {
      os.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'os');
      });
    }
    if (deviceCategory) {
      deviceCategory.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'deviceCategory');
      });
    }
    if (botCategory) {
      botCategory.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'botCategory');
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/quality/coverage`;
    return this.httpClient.request<CoverageResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Playback lifecycle event counts
   * Counts CMCD v2 Event Mode records by raw player_state value between \&#39;from\&#39; and \&#39;to\&#39;. The letter-code-to-lifecycle-event mapping (play/pause/seek/rebuffer/end) follows CTA-5004-B. When a player doesn\&#39;t report player_state at all (e.g. hls.js 1.7\&#39;s CMCD v2 event mode), states are reported as \&#39;event:&lt;e&gt;\&#39; instead (e.g. \&#39;event:bc\&#39; for a bitrate-change event) - coarser, but real counts rather than an empty response. Available only for data from the last 14 days.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdQualityLifecycleGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityLifecycleGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<PlaybackLifecycleResponse>;
  public streamAnalyticsV1PullZoneIdQualityLifecycleGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityLifecycleGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<PlaybackLifecycleResponse>>;
  public streamAnalyticsV1PullZoneIdQualityLifecycleGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityLifecycleGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<PlaybackLifecycleResponse>>;
  public streamAnalyticsV1PullZoneIdQualityLifecycleGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityLifecycleGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdQualityLifecycleGet.');
    }
    const from = requestParameters?.from;
    if (from === null || from === undefined) {
      throw new Error('Required parameter from was null or undefined when calling streamAnalyticsV1PullZoneIdQualityLifecycleGet.');
    }
    const to = requestParameters?.to;
    if (to === null || to === undefined) {
      throw new Error('Required parameter to was null or undefined when calling streamAnalyticsV1PullZoneIdQualityLifecycleGet.');
    }
    const liveId = requestParameters?.liveId;
    const videoId = requestParameters?.videoId;
    const contentType = requestParameters?.contentType;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (from !== undefined && from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>from, 'from');
    }
    if (to !== undefined && to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>to, 'to');
    }
    if (liveId) {
      liveId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'liveId');
      });
    }
    if (videoId) {
      videoId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'videoId');
      });
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/quality/lifecycle`;
    return this.httpClient.request<PlaybackLifecycleResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Rendition change count
   * Counts resolution switches detected by diffing consecutive segment resolutions per CMCD session in the CDN request log, between \&#39;from\&#39; and \&#39;to\&#39;. No client beacon required. Available only for data from the last 14 days. Can be narrowed to a single country/browser/OS/device category/bot category with the corresponding filter parameter.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdQualityRenditionChangesGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityRenditionChangesGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<RenditionChangeResponse>;
  public streamAnalyticsV1PullZoneIdQualityRenditionChangesGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityRenditionChangesGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<RenditionChangeResponse>>;
  public streamAnalyticsV1PullZoneIdQualityRenditionChangesGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityRenditionChangesGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<RenditionChangeResponse>>;
  public streamAnalyticsV1PullZoneIdQualityRenditionChangesGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityRenditionChangesGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdQualityRenditionChangesGet.');
    }
    const from = requestParameters?.from;
    if (from === null || from === undefined) {
      throw new Error('Required parameter from was null or undefined when calling streamAnalyticsV1PullZoneIdQualityRenditionChangesGet.');
    }
    const to = requestParameters?.to;
    if (to === null || to === undefined) {
      throw new Error('Required parameter to was null or undefined when calling streamAnalyticsV1PullZoneIdQualityRenditionChangesGet.');
    }
    const liveId = requestParameters?.liveId;
    const videoId = requestParameters?.videoId;
    const contentType = requestParameters?.contentType;
    const countryCode = requestParameters?.countryCode;
    const browser = requestParameters?.browser;
    const os = requestParameters?.os;
    const deviceCategory = requestParameters?.deviceCategory;
    const botCategory = requestParameters?.botCategory;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (from !== undefined && from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>from, 'from');
    }
    if (to !== undefined && to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>to, 'to');
    }
    if (liveId) {
      liveId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'liveId');
      });
    }
    if (videoId) {
      videoId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'videoId');
      });
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }
    if (countryCode) {
      countryCode.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'countryCode');
      });
    }
    if (browser) {
      browser.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'browser');
      });
    }
    if (os) {
      os.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'os');
      });
    }
    if (deviceCategory) {
      deviceCategory.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'deviceCategory');
      });
    }
    if (botCategory) {
      botCategory.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'botCategory');
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/quality/rendition/changes`;
    return this.httpClient.request<RenditionChangeResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * CMCD quality summary
   * Average bitrate, buffer length, and measured throughput, plus rebuffer/startup event counts, aggregated between \&#39;from\&#39; and \&#39;to\&#39;. Computed from CMCD v1 (Request Mode) query-string data captured at the CDN edge - requires no client beacon, but is empty for traffic where the player doesn\&#39;t send CMCD v1. Can be narrowed to a single country/browser/OS/device category/bot category with the corresponding filter parameter.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdQualitySummaryGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualitySummaryGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<QualitySummaryResponse>;
  public streamAnalyticsV1PullZoneIdQualitySummaryGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualitySummaryGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<QualitySummaryResponse>>;
  public streamAnalyticsV1PullZoneIdQualitySummaryGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualitySummaryGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<QualitySummaryResponse>>;
  public streamAnalyticsV1PullZoneIdQualitySummaryGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualitySummaryGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdQualitySummaryGet.');
    }
    const from = requestParameters?.from;
    if (from === null || from === undefined) {
      throw new Error('Required parameter from was null or undefined when calling streamAnalyticsV1PullZoneIdQualitySummaryGet.');
    }
    const to = requestParameters?.to;
    if (to === null || to === undefined) {
      throw new Error('Required parameter to was null or undefined when calling streamAnalyticsV1PullZoneIdQualitySummaryGet.');
    }
    const liveId = requestParameters?.liveId;
    const videoId = requestParameters?.videoId;
    const contentType = requestParameters?.contentType;
    const countryCode = requestParameters?.countryCode;
    const browser = requestParameters?.browser;
    const os = requestParameters?.os;
    const deviceCategory = requestParameters?.deviceCategory;
    const botCategory = requestParameters?.botCategory;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (from !== undefined && from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>from, 'from');
    }
    if (to !== undefined && to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>to, 'to');
    }
    if (liveId) {
      liveId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'liveId');
      });
    }
    if (videoId) {
      videoId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'videoId');
      });
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }
    if (countryCode) {
      countryCode.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'countryCode');
      });
    }
    if (browser) {
      browser.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'browser');
      });
    }
    if (os) {
      os.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'os');
      });
    }
    if (deviceCategory) {
      deviceCategory.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'deviceCategory');
      });
    }
    if (botCategory) {
      botCategory.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'botCategory');
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/quality/summary`;
    return this.httpClient.request<QualitySummaryResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * CMCD quality metric bucketed over time
   * Buckets a single CMCD quality metric (e.g. bitrate, buffer length) into \&#39;granularity\&#39;-sized time slices. Computed from CMCD v1 (Request Mode) query-string data captured at the CDN edge - requires no client beacon, but returns empty buckets for traffic where the player doesn\&#39;t send CMCD v1. Can be narrowed to a single country/browser/OS/device category/bot category with the corresponding filter parameter.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdQualityTimeseriesGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityTimeseriesGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<QualityTimeSeriesResponse>;
  public streamAnalyticsV1PullZoneIdQualityTimeseriesGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityTimeseriesGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<QualityTimeSeriesResponse>>;
  public streamAnalyticsV1PullZoneIdQualityTimeseriesGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityTimeseriesGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<QualityTimeSeriesResponse>>;
  public streamAnalyticsV1PullZoneIdQualityTimeseriesGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityTimeseriesGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdQualityTimeseriesGet.');
    }
    const from = requestParameters?.from;
    if (from === null || from === undefined) {
      throw new Error('Required parameter from was null or undefined when calling streamAnalyticsV1PullZoneIdQualityTimeseriesGet.');
    }
    const to = requestParameters?.to;
    if (to === null || to === undefined) {
      throw new Error('Required parameter to was null or undefined when calling streamAnalyticsV1PullZoneIdQualityTimeseriesGet.');
    }
    const metric = requestParameters?.metric;
    if (metric === null || metric === undefined) {
      throw new Error('Required parameter metric was null or undefined when calling streamAnalyticsV1PullZoneIdQualityTimeseriesGet.');
    }
    const liveId = requestParameters?.liveId;
    const videoId = requestParameters?.videoId;
    const contentType = requestParameters?.contentType;
    const countryCode = requestParameters?.countryCode;
    const browser = requestParameters?.browser;
    const os = requestParameters?.os;
    const deviceCategory = requestParameters?.deviceCategory;
    const botCategory = requestParameters?.botCategory;
    const granularity = requestParameters?.granularity;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (from !== undefined && from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>from, 'from');
    }
    if (to !== undefined && to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>to, 'to');
    }
    if (metric !== undefined && metric !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>metric, 'metric');
    }
    if (liveId) {
      liveId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'liveId');
      });
    }
    if (videoId) {
      videoId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'videoId');
      });
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }
    if (countryCode) {
      countryCode.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'countryCode');
      });
    }
    if (browser) {
      browser.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'browser');
      });
    }
    if (os) {
      os.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'os');
      });
    }
    if (deviceCategory) {
      deviceCategory.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'deviceCategory');
      });
    }
    if (botCategory) {
      botCategory.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'botCategory');
      });
    }
    if (granularity !== undefined && granularity !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>granularity, 'granularity');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/quality/timeseries`;
    return this.httpClient.request<QualityTimeSeriesResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Viewers waiting for a live stream to start
   * Total and per-country (nested per-region) count of viewers currently waiting for a specific live stream to start, resolved from a CMCD v2 custom event: the player must send e&#x3D;ce,cen&#x3D;\&quot;waiting\&quot; while the stream hasn\&#39;t started. A viewer without CMCD v2 reporting active (the player-cmcd flag) isn\&#39;t counted - a low or zero count can mean nobody\&#39;s waiting, or it can mean CMCD isn\&#39;t enabled, not that the API is broken. A country\&#39;s regions list only includes viewers GeoIP additionally resolved a region for - it can be shorter than that country\&#39;s own Viewers count, or empty.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdQualityWaitingViewersGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityWaitingViewersGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<WaitingViewersResponse>;
  public streamAnalyticsV1PullZoneIdQualityWaitingViewersGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityWaitingViewersGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<WaitingViewersResponse>>;
  public streamAnalyticsV1PullZoneIdQualityWaitingViewersGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityWaitingViewersGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<WaitingViewersResponse>>;
  public streamAnalyticsV1PullZoneIdQualityWaitingViewersGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityWaitingViewersGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdQualityWaitingViewersGet.');
    }
    const liveId = requestParameters?.liveId;
    if (liveId === null || liveId === undefined) {
      throw new Error('Required parameter liveId was null or undefined when calling streamAnalyticsV1PullZoneIdQualityWaitingViewersGet.');
    }
    const windowSeconds = requestParameters?.windowSeconds;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (liveId !== undefined && liveId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>liveId, 'liveId');
    }
    if (windowSeconds !== undefined && windowSeconds !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>windowSeconds, 'windowSeconds');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/quality/waiting-viewers`;
    return this.httpClient.request<WaitingViewersResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Watch time by geography
   * Breaks down the watch time reported by /quality/watch-time by viewer country (ISO-3166 alpha-2) between \&#39;from\&#39; and \&#39;to\&#39;. Sorted by watch time descending and capped at \&#39;limit\&#39; rows; can be narrowed to one or more countries with \&#39;countryCode\&#39;. The country is resolved from the viewer IP the player\&#39;s beacons arrived from - for beacons sent through the bunny player\&#39;s relay, the viewer address it vouches for in its signed envelope; a relay that does not, or cannot, is attributed to the relay\&#39;s own location. Sessions without a resolved country are excluded, so the rows can sum to less than /quality/watch-time over the same range. Available only for data from the last 14 days.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdQualityWatchTimeGeographyGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityWatchTimeGeographyGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<WatchTimeGeographyResponse>;
  public streamAnalyticsV1PullZoneIdQualityWatchTimeGeographyGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityWatchTimeGeographyGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<WatchTimeGeographyResponse>>;
  public streamAnalyticsV1PullZoneIdQualityWatchTimeGeographyGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityWatchTimeGeographyGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<WatchTimeGeographyResponse>>;
  public streamAnalyticsV1PullZoneIdQualityWatchTimeGeographyGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityWatchTimeGeographyGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdQualityWatchTimeGeographyGet.');
    }
    const from = requestParameters?.from;
    if (from === null || from === undefined) {
      throw new Error('Required parameter from was null or undefined when calling streamAnalyticsV1PullZoneIdQualityWatchTimeGeographyGet.');
    }
    const to = requestParameters?.to;
    if (to === null || to === undefined) {
      throw new Error('Required parameter to was null or undefined when calling streamAnalyticsV1PullZoneIdQualityWatchTimeGeographyGet.');
    }
    const liveId = requestParameters?.liveId;
    const videoId = requestParameters?.videoId;
    const contentType = requestParameters?.contentType;
    const countryCode = requestParameters?.countryCode;
    const limit = requestParameters?.limit;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (from !== undefined && from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>from, 'from');
    }
    if (to !== undefined && to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>to, 'to');
    }
    if (liveId) {
      liveId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'liveId');
      });
    }
    if (videoId) {
      videoId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'videoId');
      });
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }
    if (countryCode) {
      countryCode.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'countryCode');
      });
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/quality/watch-time/geography`;
    return this.httpClient.request<WatchTimeGeographyResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Cumulative watch time
   * Sums elapsed time between consecutive CMCD v2 Event Mode records per session where the player reported a \&#39;playing\&#39; state, between \&#39;from\&#39; and \&#39;to\&#39;. When player_state isn\&#39;t reported at all (e.g. hls.js 1.7\&#39;s CMCD v2 event mode), falls back to position (\&#39;pt\&#39;) consistency between events instead of reporting zero. SessionCount only includes sessions with at least 2 records (the same population WatchTimeSeconds is summed over) - it is not the same denominator as audience/views, which counts server-observed playback starts instead. Can be narrowed to one or more viewer countries with \&#39;countryCode\&#39; - see /quality/watch-time/geography for the accuracy caveat that carries. Available only for data from the last 14 days.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdQualityWatchTimeGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityWatchTimeGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<WatchTimeResponse>;
  public streamAnalyticsV1PullZoneIdQualityWatchTimeGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityWatchTimeGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<WatchTimeResponse>>;
  public streamAnalyticsV1PullZoneIdQualityWatchTimeGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityWatchTimeGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<WatchTimeResponse>>;
  public streamAnalyticsV1PullZoneIdQualityWatchTimeGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityWatchTimeGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdQualityWatchTimeGet.');
    }
    const from = requestParameters?.from;
    if (from === null || from === undefined) {
      throw new Error('Required parameter from was null or undefined when calling streamAnalyticsV1PullZoneIdQualityWatchTimeGet.');
    }
    const to = requestParameters?.to;
    if (to === null || to === undefined) {
      throw new Error('Required parameter to was null or undefined when calling streamAnalyticsV1PullZoneIdQualityWatchTimeGet.');
    }
    const liveId = requestParameters?.liveId;
    const videoId = requestParameters?.videoId;
    const contentType = requestParameters?.contentType;
    const countryCode = requestParameters?.countryCode;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (from !== undefined && from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>from, 'from');
    }
    if (to !== undefined && to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>to, 'to');
    }
    if (liveId) {
      liveId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'liveId');
      });
    }
    if (videoId) {
      videoId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'videoId');
      });
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }
    if (countryCode) {
      countryCode.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'countryCode');
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/quality/watch-time`;
    return this.httpClient.request<WatchTimeResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Watch time by session
   * Same per-session watch time computation as /quality/watch-time, but returns one row per session (with the content id it belongs to, when reported) instead of collapsing to a single total. Sorted by watch time - descending by default - and capped at \&#39;limit\&#39; rows. Can be narrowed to one or more viewer countries with \&#39;countryCode\&#39;. Available only for data from the last 14 days.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdQualityWatchTimeSessionsGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityWatchTimeSessionsGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<WatchTimeSessionsResponse>;
  public streamAnalyticsV1PullZoneIdQualityWatchTimeSessionsGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityWatchTimeSessionsGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<WatchTimeSessionsResponse>>;
  public streamAnalyticsV1PullZoneIdQualityWatchTimeSessionsGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityWatchTimeSessionsGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<WatchTimeSessionsResponse>>;
  public streamAnalyticsV1PullZoneIdQualityWatchTimeSessionsGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdQualityWatchTimeSessionsGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdQualityWatchTimeSessionsGet.');
    }
    const from = requestParameters?.from;
    if (from === null || from === undefined) {
      throw new Error('Required parameter from was null or undefined when calling streamAnalyticsV1PullZoneIdQualityWatchTimeSessionsGet.');
    }
    const to = requestParameters?.to;
    if (to === null || to === undefined) {
      throw new Error('Required parameter to was null or undefined when calling streamAnalyticsV1PullZoneIdQualityWatchTimeSessionsGet.');
    }
    const liveId = requestParameters?.liveId;
    const videoId = requestParameters?.videoId;
    const contentType = requestParameters?.contentType;
    const countryCode = requestParameters?.countryCode;
    const descending = requestParameters?.descending;
    const limit = requestParameters?.limit;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (from !== undefined && from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>from, 'from');
    }
    if (to !== undefined && to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>to, 'to');
    }
    if (liveId) {
      liveId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'liveId');
      });
    }
    if (videoId) {
      videoId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'videoId');
      });
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }
    if (countryCode) {
      countryCode.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'countryCode');
      });
    }
    if (descending !== undefined && descending !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>descending, 'descending');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/quality/watch-time/sessions`;
    return this.httpClient.request<WatchTimeSessionsResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }
}
